import logger from 'utils/logger.util';
import isFn from 'utils/predicates/function/isFn.util';

const L = logger('beCashup'); // eslint-disable-line no-unused-vars

// almost the identity function, except Redux has issues with undefined, so null is the default
const defaultReducer = ($) => $ ?? null;

const asReducer = (fn) => (isFn(fn) ? fn : defaultReducer);

export { defaultReducer };

export default asReducer;
